import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  marginLeft: 'auto',
};
